// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bl_dK";
export var articleInfoItem = "bl_dL";
export var itemChild = "bl_dM";